import { formatBigInt } from '@/utils/value-format';
import TpSlEdit from '../tpsl-edit';
import { useOrdersStore } from '@/store/use-orders-store';
import { useAccountStore } from '@/store/use-account-store';
import { OrderType } from '@/types';
import { useStore } from 'zustand';
import { useMarketStore } from '@/store/use-markets-store';

type Props = {
  symbol: string;
};

export default function Tpsl({ symbol }: Props) {
  const address = useAccountStore((state) => state.address);
  const minTpPrice = useOrdersStore((state) => {
    const { orders, newOrderIds } = state.getOrders(address);
    const tps = Array.from(newOrderIds).filter(
      (id) =>
        orders[id].symbol === symbol &&
        orders[id].orderType === OrderType.TAKE_PROFIT,
    );
    if (tps.length === 0) return;
    return tps.reduce((prev, id) => {
      const { limitPrice } = orders[id];
      if (limitPrice < prev) {
        return limitPrice;
      }
      return prev;
    }, orders[tps[0]].limitPrice);
  });
  const maxSlPrice = useOrdersStore((state) => {
    const { orders, newOrderIds } = state.getOrders(address);
    const sls = Array.from(newOrderIds).filter(
      (id) =>
        orders[id].symbol === symbol &&
        orders[id].orderType === OrderType.STOP_LOSS,
    );
    if (sls.length === 0) return;
    return sls.reduce((prev, id) => {
      const { limitPrice } = orders[id];
      if (limitPrice > prev) {
        return limitPrice;
      }
      return prev;
    }, orders[sls[0]].limitPrice);
  });

  const priceDecimals = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.priceDecimals,
  );

  return (
    <div className="flex items-center gap-3">
      <div className="text-ellipsis whitespace-nowrap">
        {formatBigInt(minTpPrice, priceDecimals, {
          style: 'currency',
          digits: 2,
        })}{' '}
        /{' '}
        {formatBigInt(maxSlPrice, priceDecimals, {
          style: 'currency',
          digits: 2,
        })}
      </div>
      <TpSlEdit symbol={symbol} />
    </div>
  );
}
